import axios from 'axios'

const instance = axios.create({
    //baseURL: 'http://localhost:3008',
    baseURL: 'https://api.expoferiatrujillo.com',
    headers: {
        'Content-Type': 'application/json',
    },
})

export default instance
